<template>
    <v-container>
        <div class="d-flex" style="margin-bottom: 20px; margin-top: 10px">
            <div class="text-h3">Пользователи</div>
            <v-spacer />
            <v-btn @click.stop="add">
                <v-icon>mdi-plus</v-icon>&nbsp;Пользователь
            </v-btn>
        </div>

        <UserEditor v-show="editingUser" v-model="editingUser" @finish="editFinished" />

        <UserBrowser
            ref="browser"
            :filters="{}"
            @edit="e => loadAndEdit(e.id)"
        />
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject, Prop} from 'vue-property-decorator'
import Api from '@/services/Api'
import UserEditor from '@/components/modals/UserEditor.vue'
import {createUser, UserDraft} from '@/models/User'
import UserBrowser from '@/components/browsers/UserBrowser.vue'

@Component({
    components: {UserBrowser, UserEditor},
})
export default class UsersView extends Vue
{
    @Inject('api') private api!: Api

    @Prop({type: Boolean, default: false})
    isCreating!: boolean

    editingUser: UserDraft | null = null

    async created() {
        if (this.isCreating) {
            this.add()
        } else {
            const id = parseInt(this.$route.params.id)
            if (id) {
                await this.loadAndEdit(id)
            }
        }
    }

    async fetchOne(id: number) {
        return await this.api.getUser(id)
    }

    async loadAndEdit(id: number) {
        const user = await this.fetchOne(id)
        this.edit(user)
    }

    add() {
        this.edit(createUser())
    }

    edit(user: UserDraft) {
        this.editingUser = user
        this.$router.push(user.id ? '/users/edit/' + user.id : '/users/create').catch(() => true)
    }

    editFinished() {
        this.editingUser = null
        const browser = this.$refs.browser as UserBrowser
        browser.refresh()
        this.$router.push('/users')
    }
}
</script>
